import { render, staticRenderFns } from "./EmployeesPreview.vue?vue&type=template&id=3953741e&scoped=true&"
import script from "./EmployeesPreview.vue?vue&type=script&lang=js&"
export * from "./EmployeesPreview.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesPreview.vue?vue&type=style&index=0&id=3953741e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3953741e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VTooltip})
